import {useContext} from 'react';
import { HashRouter, Routes, Route } from "react-router-dom";

import { UIContext } from '../../contexts/UIContext';

import About from '../../pages/About/About';
import DenounceDetails from '../../pages/DenounceDetails/DenounceDetails';
import DenounceUpdate from '../../pages/DenounceUpdate/DenounceUpdate';
import VectorFoci from '../../pages/VectorFoci/VectorFoci';
import VectorFocusDetails from '../../pages/VectorFocusDetails/VectorFocusDetails';
import VectorFocusUpdate from '../../pages/VectorFocusUpdate/VectorFocusUpdate';
import VectorFocusCreate from '../../pages/VectorFocusCreate/VectorFocusCreate';
import Denounces from '../../pages/Denounces/Denounces';
import Home from '../../pages/Home/Home';
import VectorFocusMonitoring from '../../pages/VectorFocusMonitoring/VectorFocusMonitoring';
import Login from '../../pages/Login/Login';
import Profile from '../../pages/Profile/Profile';
import RecoverPassword from '../../pages/RecoverPassword/RecoverPassword';
import RememberPassword from '../../pages/RememberPassword/RememberPassword';
import Splash from '../../pages/Splash/Splash';
import Tutorial from '../../pages/Tutorial/Tutorial';
import WorkingAreas from '../../pages/WorkingAreas/WorkingAreas';
import WorkingAreaDetails from '../../pages/WorkingAreaDetails/WorkingAreaDetails';

import AlertMessage from '../../components/AlertMessage/AlertMessage';

import './App.scss';

function App() {
  const {
    showAlertMessage,
    alertMessageType,
    alertMessageTitle,
    alertMessage,
    handleCloseAlertMessage
  } = useContext(UIContext);

  return (
    <div className="App">
      <HashRouter>
        <Routes>
          <Route exact path="/" element={<Splash/>} />
          <Route path="/tutorial" element={<Tutorial/>} />
          <Route path="/login" element={<Login/>} />
          <Route path="/recover-password" element={<RecoverPassword/>} />
          <Route path="/remember-password" element={<RememberPassword/>} />
          <Route path="/home" element={<Home/>} />
          <Route path="/monitoring" element={<VectorFocusMonitoring/>} />
          <Route path="/profile" element={<Profile/>} />
          <Route path="/denounces" element={<Denounces/>} />
          <Route path="/denounce-details" element={<DenounceDetails/>} />
          <Route path="/denounce-update" element={<DenounceUpdate/>} />
          <Route path="/vector-foci" element={<VectorFoci/>} />
          <Route path="/vector-focus-details" element={<VectorFocusDetails/>}>
            <Route path=":id" element={<VectorFocusDetails/>} />
          </Route>
          <Route path="/vector-focus-update" element={<VectorFocusUpdate/>} />
          <Route path="/vector-focus-create" element={<VectorFocusCreate/>} />
          <Route path="/working-areas" element={<WorkingAreas/>} />
          <Route path="/working-area" element={<WorkingAreaDetails/>} />
          <Route path="/about" element={<About/>} />
        </Routes>
      </HashRouter>
      <AlertMessage
        show={showAlertMessage}
        type={alertMessageType}
        title={alertMessageTitle}
        message={alertMessage}
        handleCloseAlertMessage={handleCloseAlertMessage}
      />
    </div>
  );
}

export default App;
